var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereumEthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 784.37 1277.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M392.07 0L383.5 29.11 383.5 873.74 392.07 882.29 784.13 650.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 0L0 650.54 392.07 882.29 392.07 472.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M392.07 956.52L387.24 962.41 387.24 1263.28 392.07 1277.38 784.37 724.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 1277.38L392.07 956.52 0 724.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M392.07 882.29L784.13 650.54 392.07 472.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M0 650.54L392.07 882.29 392.07 472.33z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumEthLogo);
export default __webpack_public_path__ + "static/media/ethereum-eth-logo.26217b1803f059df7181cdeb20810cd0.svg";
export { ForwardRef as ReactComponent };